import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { apiPost } from "./apiClient";
import "./TermsOfService.css";

const TERMS_VERSION = "v1.0";

export default function TermsConsent() {
  const [checked, setChecked] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // If there's no user in localStorage, send them to login
    const uid = localStorage.getItem("user");
    if (!uid) {
      navigate("/");
    }
  }, [navigate]);

  const accept = async () => {
    if (!checked) return;
    setSubmitting(true);

    try {
      await apiPost("/users/accept-terms", { terms_version: TERMS_VERSION });
      navigate("/questionnaire");
    } catch (err) {
      console.error("Error accepting terms:", err);
      alert("ثبت پذیرش قوانین با خطا مواجه شد. لطفاً دوباره امتحان کنید.");
    }

    setSubmitting(false);
  };

  return (
    <div className="tos-wrapper">
      <div className="tos-container">
        <h1>پذیرش شرایط و قوانین</h1>
        <p>
          لطفاً{" "}
          <Link to="/terms" target="_blank" rel="noopener noreferrer">
            قوانین و شرایط
          </Link>{" "}
          را مطالعه کرده و سپس تأیید نمایید.
        </p>

        <div className="terms-checkbox" style={{ marginTop: 16 }}>
          <input
            type="checkbox"
            id="acceptTermsNow"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
          />
          <label htmlFor="acceptTermsNow">با قوانین موافقم</label>
        </div>

        <button
          className="accept-button"
          disabled={!checked || submitting}
          onClick={accept}
        >
          {submitting ? "در حال ثبت..." : "تأیید و ادامه"}
        </button>
      </div>
    </div>
  );
}
